var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v(" "+_vm._s(_vm.text)+" "),_c('router-link',{attrs:{"to":_vm.to},domProps:{"textContent":_vm._s(_vm.linkText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }